import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
//import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
/*import './Theme.css'*/
import 'bootstrap/dist/css/bootstrap.min.css'
import 'font-awesome/css/font-awesome.min.css'
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import 'react-toastify/dist/ReactToastify.css'
/*import 'pretty-checkbox/dist/pretty-checkbox.css'*/
import { UserContextProvider } from './Component/User/UserContext';
import { ToastContainer } from 'react-toastify';
import * as serviceWorker from './serviceWorker';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Backtotop from './Global/Backtotop';
import { HashRouter } from 'react-router-dom'
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
      <UserContextProvider  >
               <App>
               </App>
         <ToastContainer></ToastContainer>
         <Backtotop></Backtotop>
      </UserContextProvider>
      
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
//unregister();
serviceWorker.unregister();
